import { render } from "./ScreenshotGuide.vue?vue&type=template&id=41c3e6d0"
import script from "./ScreenshotGuide.vue?vue&type=script&lang=js"
export * from "./ScreenshotGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__